export default function registerTutorialSearch(Alpine) {
  Alpine.data("tutorialSearch", ({ sections } = { sections: {} }) => ({
    query: "",
    sections,

    init() {
      this._onKeydown = (e) => {
        if (this._typingInForm(e.target)) return;

        if (e.key === "/") {
          e.preventDefault();
          this.$refs.tutorialSearch?.focus();
        } else if (e.key === "Escape" && this.query !== "") {
          this.query = "";
        }
      };
      document.addEventListener("keydown", this._onKeydown);

      this.$nextTick(() => {
        if (!window.location.hash) return;
        const target = document.querySelector(window.location.hash);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },

    destroy() {
      document.removeEventListener("keydown", this._onKeydown);
    },

    _typingInForm(el) {
      if (!el) return false;
      if (el === this.$refs.tutorialSearch) return false;
      const tag = el.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || el.isContentEditable;
    },

    get normalizedQuery() {
      return this.query.trim().toLowerCase();
    },

    matchesIndex(category, index) {
      const q = this.normalizedQuery;
      if (q === "") return true;
      const text = this.sections[category]?.[index];
      return typeof text === "string" && text.includes(q);
    },

    sectionVisible(category) {
      const q = this.normalizedQuery;
      if (q === "") return true;
      return (this.sections[category] || []).some((t) => t.includes(q));
    },

    anyVisible() {
      if (this.normalizedQuery === "") return true;
      return Object.keys(this.sections).some((c) => this.sectionVisible(c));
    }
  }));
}
